// Design tokens for Naive UI NConfigProvider.
// Status colors map string keys (running, failed, etc.) to Naive UI tag types.

import type { GlobalThemeOverrides } from 'naive-ui'

export const themeOverrides: GlobalThemeOverrides = {
  common: {
    primaryColor: '#3366FF',
    primaryColorHover: '#5983FF',
    primaryColorPressed: '#274ACC',
    successColor: '#18A058',
    errorColor: '#D03050',
    warningColor: '#F0A020',
    infoColor: '#909399',
    borderRadius: '6px',
    fontFamily: 'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
}

// Maps a status string (health state or deployment status) to a Naive NTag
// type. Used by StatusBadge.vue and inline tag renderers.
export type TagType = 'default' | 'success' | 'error' | 'warning' | 'info'

const statusMap: Record<string, TagType> = {
  running: 'success',
  success: 'success',

  failed: 'error',
  missing: 'error',
  exited: 'error',
  dead: 'error',

  pending: 'warning',
  building: 'warning',
  activating: 'warning',
  unhealthy: 'warning',
  restarting: 'warning',

  created: 'info',
  paused: 'info',
  unknown: 'info',
}

export function tagType(status: string): TagType {
  return statusMap[status] || 'info'
}
